import React                     from 'react';
import { Observe }               from 'rewire-core';
import {
  WithStyle,
  FormView,
}                                from 'rewire-ui';
import { Theme }                 from '@material-ui/core/styles';
import DraggableResizableDialog  from '../ui/DraggableResizableDialog';
import postedScheduleDialogModel from './PostedScheduleDialogModel';
import { withStyles }            from '../utility/styles';

const styles = (_theme: Theme) => ({
});

interface IPostedScheduleDialogProps {
}

type PostedScheduleDialogProps = WithStyle<ReturnType<typeof styles>>;

class PostedScheduleDialog extends React.PureComponent<PostedScheduleDialogProps> {
  constructor(props: PostedScheduleDialogProps) {
    super(props);
  }

  componentWillUnmount() {
    postedScheduleDialogModel.reset();
  }

  renderDialogContents = React.memo((): JSX.Element => {
    return <Observe render={() => (
      <FormView form={postedScheduleDialogModel.form} onSubmit={postedScheduleDialogModel.actionFn('save')}>
        {postedScheduleDialogModel.form.fields.map((field: any) =>
          <div key={field.name} className='content'>
            <field.Editor className='span1' />
          </div>
        )}
      </FormView>
    )} />;
  });

  render() {
    return <Observe render={() => (
      <DraggableResizableDialog defaultWidth='xs' DialogProps={{dialog: postedScheduleDialogModel}} DraggableResizableBoxProps={{minWidth: '250px', minHeight: '213px'}}>
        <this.renderDialogContents />
      </DraggableResizableDialog>
    )} />;
  }
}

export default withStyles<IPostedScheduleDialogProps>(styles, PostedScheduleDialog);
